import * as React from "react";
import { Check, X } from "lucide-react";
import { Button } from "./button";
import { getToasts, subscribeToToasts } from "./toast-store";
import { toast } from "./toast";
import { cn } from "@/lib/utils";

function Toaster({ className, ...props }: React.ComponentProps<"div">) {
  const items = React.useSyncExternalStore(subscribeToToasts, getToasts, getToasts);
  return (
    <div
      aria-label="Notifications"
      className={cn(
        "pointer-events-none fixed right-4 bottom-4 z-[100] flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2",
        className,
      )}
      {...props}
    >
      {items.map((item) => (
        <div
          key={item.id}
          role="status"
          aria-live="polite"
          className="pointer-events-auto flex min-h-12 items-center gap-3 rounded-xl border bg-popover px-4 py-3 text-sm text-popover-foreground shadow-dialog"
        >
          <Check className="size-4 shrink-0 text-success" aria-hidden />
          <span className="min-w-0 flex-1">{item.message}</span>
          {item.action && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                item.action?.onClick();
                toast.dismiss(item.id);
              }}
            >
              {item.action.label}
            </Button>
          )}
          <button
            type="button"
            aria-label="Dismiss notification"
            className="rounded p-1 text-muted-foreground hover:bg-accent"
            onClick={() => toast.dismiss(item.id)}
          >
            <X className="size-4" aria-hidden />
          </button>
        </div>
      ))}
    </div>
  );
}

export { Toaster };
